"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../../common-styled-components");
const useSortedData_1 = require("../../../../hooks/useSortedData");
const ExportCsvButton_1 = require("../ExportCsvButton");
const voyageTableColumns = () => [
    {
        key: "fuel",
        label: "Fuel",
        sortableKey: "fuel",
    },
    {
        key: "engine",
        label: "Engine",
        sortableKey: "engine.id",
    },
    {
        key: "amount",
        label: "Amount (t)",
        sortableKey: "amount",
    },
    {
        key: "price",
        label: "Price",
        sortableKey: "price",
    },
    {
        key: "is_half_rate",
        label: "Half rate",
        sortableKey: "is_half_rate",
    },
];
const CellContent = ({ index, usage, contentKey, metadata, }) => {
    switch (contentKey) {
        case "index":
            return (0, jsx_runtime_1.jsx)("div", { children: index });
        case "ship":
            return (0, jsx_runtime_1.jsx)("div", { children: usage.ship.name });
        case "fuel":
            return (0, jsx_runtime_1.jsx)("div", { children: metadata.fuels[usage.fuel]?.name });
        case "engine":
            return (0, jsx_runtime_1.jsx)("div", { children: metadata.engines[usage.engine?.type]?.engine.name });
        case "is_half_rate":
            return (0, jsx_runtime_1.jsx)("div", { children: usage.is_half_rate ? "Y" : "N" });
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: usage[contentKey].toString() });
    }
};
const UsageTable = ({ usages, metadata, isInAdminTools, }) => {
    const { sortedData, sortMethod, sortDirection, setSort } = (0, useSortedData_1.useSortedData)(usages, "amount", -1);
    const columns = voyageTableColumns();
    const csvColumns = columns.map((column) => ({
        header: column.label,
        getValue: (usage) => {
            switch (column.key) {
                case "index":
                    return "";
                case "ship":
                    return usage.ship.name;
                case "fuel":
                    return metadata.fuels[usage.fuel]?.name ?? "";
                case "engine":
                    return metadata.engines[usage.engine?.type]?.engine.name ?? "";
                case "is_half_rate":
                    return usage.is_half_rate ? "Y" : "N";
                default:
                    return usage[column.key]?.toString() ?? "";
            }
        },
    }));
    return (metadata && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Row, { children: (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: sortedData, columns: csvColumns, tableName: "usages" }) }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.SortableTH, { setSort: setSort, sortKey: c.sortableKey, sortDirection: sortMethod && sortMethod === c.sortableKey
                                    ? sortDirection
                                    : undefined, children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedData.map((usage, index) => {
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { index: index + 1, contentKey: c.key, usage: usage, isInAdminTools: isInAdminTools, metadata: metadata }) }, c.key))) }, usage.id));
                        }) })] })] })));
};
exports.UsageTable = UsageTable;
